type Props = {
  icon?: any;
  size?: string;
  onClick: any;
  title: any;
  type?: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  disabled?: boolean;
  role?: string;
};

const Button = ({ icon, size, onClick, title, type, children, disabled, role }: Props) => {
  return (
    <button
      className={`btn btn--${size || 'md'}`}
      onClick={onClick}
      title={title}
      type={type || 'button'}
      disabled={disabled}
      role={role || 'button'}
    >
      {icon ? icon : null}
      {children}
    </button>
  );
};

export default Button;
